/**
 * 🏠 PAGE D'ACCUEIL : accessible à tous, connectés ou non, sans redirection.
 * Elle s'affiche immédiatement (l'en-tête se met à jour dès que la session est vérifiée).
 */
const HomeRoute = ({ children }) => children;

export default HomeRoute;
